import { render, staticRenderFns } from "./NewGroupFlightRequest.vue?vue&type=template&id=7b15da78&scoped=true"
import script from "./NewGroupFlightRequest.vue?vue&type=script&lang=js"
export * from "./NewGroupFlightRequest.vue?vue&type=script&lang=js"
import style0 from "./NewGroupFlightRequest.vue?vue&type=style&index=0&id=7b15da78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15da78",
  null
  
)

export default component.exports